
<div class="searchbox">
    <div class="col-md-1 col-sm-12 col-xs-12" style="float: right; margin-top: 1%;">
        <button mat-icon-button aria-label="close dialog" style="float: right;" mat-dialog-close disableRipple>
            <mat-icon>close</mat-icon>
        </button>
    </div>
<mat-form-field appearance="outline" class="col-md-11 col-sm-12 col-xs-12">
    <mat-label>Search</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
    <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
</div>

<div class="tabContentContainer">
    <mat-card class="mat-elevation-z8 m-4">
    <mat-table #matTable [dataSource]="dataSource" class="dataTable" matSort>

        <!-- Action Column -->
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>Select</mat-header-cell>
            <mat-cell *matCellDef="let row" (click)="selectPid(row)">
                <mat-icon style="cursor: pointer;">check_circle_outline</mat-icon>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="permanent_id">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                Institute Permanent Id
            </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.PERMANENT_ID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="institute_name">
            <mat-header-cell *matHeaderCellDef>
                Institute Name</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.CURRENT_INSTITUTE_NAME}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="institute_district">
            <mat-header-cell *matHeaderCellDef>
                Institute District</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.INSTI_CITY}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="institute_state">
            <mat-header-cell *matHeaderCellDef>
                Institute State</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.INSTI_STATE}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="institute_add">
            <mat-header-cell *matHeaderCellDef>
                Institute Address</mat-header-cell>
            <mat-cell *matCellDef="let row" style="padding-right: 25px !important;"> {{row?.CURRENT_INSTITUTE_ADDRESS}} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
    </mat-table>

    <div *ngIf="dataSource.data.length === 0">
        <br>
        <br>
        <p class="no-records-found"> No Records Found! </p>
    </div>

<mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons>
</mat-paginator>

</mat-card>
</div>